<template>
	<div>
		<div class="row">
			<b-tabs pills v-model="tabIndex">
				<b-tab v-for="(i,idx) in tabList" :key="idx" :title="i.name">
				</b-tab>
				<template #tabs-end>
					<b-nav-item class="filter" role="presentation" 
						@click.prevent="searchFilterButtonClick" href="#"><i class="fas fa-angle-down icon-down"></i><i class="fas fa-angle-up icon-up"></i></b-nav-item>
				</template>
			</b-tabs>
		</div>
		<div class="row">
			<div class="col-md-12 search form minimize"> 
			
				<form class="search fuel formsearch" v-on:change="resumePilihan">
					<div class="button_attach_detach" style="float:right;">
						<b-button @click="floatingSearchForm" class="attach detach" variant="light" href="#"><i class="fas fa-angle-right"></i></b-button>
					</div>
					<div class="row">
						<div class="col-md-6 form-group">
							<ReportParamDateRange title="Date" v-model="date" />
						</div>
						<div class="col-md-6 form-group">
							<ReportParamSelect title="Periods" name="period" v-model="period" :options="options.period" />
						</div>
					</div>
					<div class="row">
						<div class="col-md-3 form-group">
							<ReportParamSelect title="Detail" name="detail1" v-model="detail1" :options="options.detail1" />
						</div>
						<div class="col-md-9 form-group">
							<ReportParamSearch title="Customer Name" v-model="cust" :options="customer.list" fldid="CustomerId" fldinfo="CustomerName" />
						</div>
					</div>
					<div class="row">
						<div class="col-md-6 form-group">
							<ReportParamSelect title="Customer Group" name="group" v-model="group" :options="options.group" />
						</div>
						<div class="col-md-3 form-group">
							<ReportParamSelect title="Status" name="active" v-model="active" :options="options.active" />
						</div>
						<div class="col-md-3 form-group">
							<ReportParamSelect title="Chart" name="chartparam" v-model="chartparam" :options="options.chartparam" />
						</div>
					</div>
					<div class="row">
						<div class="col-md-6 form-group">
							<ReportParamSelect title="Category" name="category" v-model="category" :options="options.category" />
						</div>
					</div>

				</form>
			</div> 
		</div> 
		<div class="row" v-if="tabIndex==0">
			<div class="col-md-6"><input type="checkbox" v-model="showchart"> Show Chart </div>
			<div class="col-md-6" v-if="showchart"><input type="checkbox" v-model="stacked"> Stacked </div>
		</div> 
		<LineChart :data="chartdata" :width="500" :height="280" v-if="showchart && tabIndex==0" />
		
		<div class="row">
			<div class="col-md-12 mx-auto">
				<div class="h-100 d-flex align-items-center justify-content-center">
					<ReportResultTable reportname="FuelReport" :reportdata="reportdata" :reporturl="urlRequestParams"/>
					<Loader :loading="this.loading.table" :customclass="''" class="child"/>
				</div>
			</div>
		</div>

	</div>
</template>

<script>

import Customer from '@/components/page/Customer.js'
import LineChart from '@/components/chart/BarChart.js'
import ReportParamSearch from '@/views/pages/ReportParamSearch.vue'
import ReportParamDateRange from '@/views/pages/ReportParamDateRange.vue'
import ReportParamSelect from '@/views/pages/ReportParamSelect.vue'
import ReportResultTable from '@/views/pages/ReportResultTable2.vue'
import { Rainbow, Config, Penanggalan, AxiosWithJar } from '@/utility.js'
import Loader from '@/components/loader/Loader.vue'


export default
{
	extends:Customer,
	components: {
		LineChart,
		ReportParamSelect,
		ReportResultTable,
		ReportParamSearch,
		ReportParamDateRange,
		Loader,
	},
	data() {
		return {
			date: { 
				Start: this.$route.query.dateStart ? this.$route.query.dateStart : Penanggalan().tahunSekarang,
				End: this.$route.query.dateEnd ? this.$route.query.dateEnd : Penanggalan().kemarin, 
			},
			urlRequestParams: '',
			options: {
				period:[
					{ value: '', name: 'ALL' },
					{ value: 'monthly', name: 'MONTHLY'  },
					{ value: 'yearly', name: 'YEARLY' },
				],
				detail1:[
					{ value: "", name: "ALL" }, 
					{ value: "customer", name: "BY CUSTOMER" }, 
				],
				category:[
					{ value: "", name: "ALL" }, 
					{ value: "tipe", name: "BY TYPE", field: "Tipe" }, 
					{ value: "category", name: "BY CATEGORY", field: "Category" }, 
					{ value: "RFID", name: "RFID" }, 
					{ value: "VOUCHER", name: "VOUCHER" }, 
					{ value: "STORE", name: "STORE" }, 
					{ value: "LPG", name: "LPG" }, 
				],
				group:[
					{ value: "", name: "ALL" }, 
					{ value: "group", name: "BY GROUP", field: "GroupName"  }, 
					{ value: "34", name: "PEMERINTAH" }, 
					{ value: "58", name: "AFILIASI" }, 
					{ value: "59", name: "SWASTA" },
					{ value: "P1", name: "PANGKALAN LPG" },
				],
				active:[
					{ value: "", name: "ALL" }, 
					{ value: "1", name: "ACTIVE" }, 
					{ value: "0", name: "NON ACTIVE" }, 
				],
				chartparam:[
					{ value: "Amount", name: "BY AMOUNT" }, 
					{ value: "CustCount", name: "BY NUM OF CUSTOMER" }, 
				],
			},
			tabList:[
				{name:'Sales B2B'},
			],
			tabIndex: this.$route.query.tab ? this.$route.query.tab : 0, 
			reportdata: [],
			chartdata: [],
			showchart: false,
			stacked: true,
			period: this.$route.query.period ? this.$route.query.period : '',
			detail1: this.$route.query.detail1 ? this.$route.query.detail1 : '',
			category: this.$route.query.category ? this.$route.query.category : 'category',
			group: this.$route.query.group ? this.$route.query.group : '',
			cust: this.$route.query.cust ? this.$route.query.cust : '',
			active: this.$route.query.active ? this.$route.query.active : '',
			chartparam: "Amount",
		}
	},

	watch:
	{
		tabIndex() { this.resumePilihan() },
		date(){ this.resumePilihan() },
		cust() { this.resumePilihan() },
		reportdata() { this.refreshChart(); },
		stacked() { this.refreshChart(); },
	},      
	mounted(){
		Array.from(document.querySelectorAll('aside li.nav-item a')).map((e)=>{e.classList.remove('active')})
		document.querySelector('li.nav-item a.'+window.location.pathname.split('/')[1]).classList.add('active')
		this.$emit('childrenRoute')
		this.loadCustomerList()
		this.resumePilihan()
	},
	methods:{

		refreshChart() {
			let opt = this.getoption(this.category, this.options.category)
			let a = opt && opt.field ? opt.field : ""

			opt = this.getoption(this.group, this.options.group)
			if (opt && opt.field) a = opt.field
			
			let b = "Period"
			let c = Rainbow

			let div = this.chartparam == "Amount" ? 1000000 : 1;
			
			this.chartdata = this.processBarChart(this.reportdata.data, a, "", this.chartparam, false, b, "", div, 2, c, false, false, false, this.stacked);
		},
		
		floatingSearchForm(){
			document.querySelector('.search.form').classList.toggle('floating')            
		},
		
		async resumePilihan(){

			this.urlRequestParams=Config().apiURL
			if (this.tabIndex == 0) this.urlRequestParams+='/customer/customerreport?'

			this.urlRequestParams+='&date-range-start='+this.date.Start
			this.urlRequestParams+='&date-range-end='+this.date.End
			this.urlRequestParams+='&period='+this.period
			this.urlRequestParams+='&detail='+this.detail1
			this.urlRequestParams+='&category='+this.category
			this.urlRequestParams+='&group='+this.group
			this.urlRequestParams+='&customer='+this.cust
			this.urlRequestParams+='&active='+this.active

			this.loading.table = true;
			AxiosWithJar().get(this.urlRequestParams)
				.then((response)=>{ 
					this.reportdata = response.data;
				})
				.catch(error => {
					console.log(error)
					//this.errored = true
					//error.response.data
				})
				.finally(() => {
					this.loading.table = false;
				})

        },

		searchFilterButtonClick(){
			document.querySelector('li.filter').classList.toggle('down')
			var select=document.querySelectorAll('.search.form')
			Array.from(select).map((e)=>{e.classList.toggle('minimize')})
		}
	}
}
</script>
<style>
    .tabs .card-header{ padding-bottom:0px ;}
    .nav.nav-pills { background: rgba(20,109,182,.75) !important; border-radius: 10px 10px 0px 0px !important; padding: 0px !important; margin-top: 10px; }
    .nav.nav-pills .nav-link { color: #f8f9fa !important; border-radius: 5px 0px 0px 0px !important; background-color: none !important; margin-right: 10px !important; font-weight: 500; padding: 15px 20px; font-size: 0.875rem; }
    .nav.nav-pills .nav-link.active{ font-weight: bold; color: #f8f9fa  !important; background-color: transparent  !important;}
    .tab-pane.active { transition: all 0.5s ease-in-out; }
    .tab-pane.card-body { flex: 1 1 auto; padding: 0px 8px;  transition: all 0.5s ease-in-out;}
    .nav.nav-pills li.filter .nav-link{ position: absolute; right:0px; bottom: 0px; top: 0px; display: flex;
    align-items: center; }
    

.search.form { background:#f8f9fa; border-radius:0px 0px 5px 5px; color:#666; padding:20px; transition: all 0.5s ease-in-out;}
.search.form.minimize{ padding:0px; height:2px; overflow:hidden; }
.search.form.floating {
    position: fixed;
    right: 0px;
    bottom: 0px;
    width: 750px;
    height: 300px;
    z-index: 9;
    background: rgba(172,196,55,.75);
    padding: 20px;
    border-radius: 15px 15px 0px 15px;
    overflow-Y: scroll;
    }
    .table .card .card-header{ display:none;}
    .table .card .card-body{ padding: 0px;}
    .table.pdf{ border:0px; }
    .table.pdf tr,.table.pdf td,.table.pdf th{ border:0px; }
    .table.pdf tbody tr:nth-child(2n+2){ background:#f1f1f1; }
    
    .table.pdf thead tr{ background: #ccc; color:#333;}
 

    .filter .icon-up { display: flex; }
    .filter.down .icon-up { display: none; }
    .filter .icon-down { display: none; }
    .filter.down .icon-down { display: flex; }


</style>